import { render } from "./ProviderSummary.vue?vue&type=template&id=08d7bfa8"
import script from "./ProviderSummary.vue?vue&type=script&lang=js"
export * from "./ProviderSummary.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__